import mitt from 'mitt';
export default mitt(); // 导出一个全局事件总线实例